import FDCNotificationsProvider, {
  useFDCNotificationsContext,
} from './FDCNotificationsContext'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import CIMSNotifications from 'components/CIMSNotifications'
import { FDCNotificationEvent } from '@cims-online/shared'
import { useEditFn } from './hooks/useEdit'
import FDCNotificationDetails from './components/FDCNotificationsDetails'
import ViewFDCNotificationEvent from './components/ViewFDCNotificationEvent'
import FDCNotificationEventPrefix from './components/FDCNotificationEventPrefix'

const InnerNotifications: React.FC = () => {
  const { fetching, refetch: onReload } = useFDCNotificationsContext()
  const editFn = useEditFn()
  return (
    <CIMSNotifications
      onReload={onReload}
      loading={fetching}
      details={<FDCNotificationDetails />}
      events={FDCNotificationEvent.values}
      prefix={<FDCNotificationEventPrefix />}
      view={<ViewFDCNotificationEvent />}
      edit={editFn}
    />
  )
}

const Notifications: React.FC = () => {
  return (
    <RecipientsSelectProvider>
      <FDCNotificationsProvider>
        <InnerNotifications />
      </FDCNotificationsProvider>
    </RecipientsSelectProvider>
  )
}

export default Notifications
